@use '@design/design-tokens/border-radius/border-radius' as *;

.listEntityItemRoot {
  @include border-radius-r1;

  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  cursor: pointer;
  border: none;
  background: none;

  &:hover {
    background-color: var(--surface-hover);
  }

  &,
  &:focus-visible {
    outline: none;
  }

  &.isFocused {
    &,
    &:focus-visible {
      background-color: var(--surface-hover);
    }
  }

  &.isDisabled {
    cursor: default;
  }
}

.details {
  display: flex;
  gap: 16px;
}

.leftPart {
  display: flex;
  align-items: center;
  gap: 8px;
}
